export const EVENTS = {
  HAMBURGER_MENU_OPENED: "Hamburger Menu Opened",
  HAMBURGER_MENU_CLOSED: "Hamburger Menu Closed",
  BET_TYPE_SELECTED: "Program Bet Type Selected",
  NAVIGATION_LINK_CLICKED: "Navigation Link Clicked"
};
